import Cookies from 'universal-cookie';

// The map's toggles, shared by kartvy and listvy and kept across view switches and reloads: the colour metric
// (Färgkarta), the Färger mode (hideMap / hideLines, colourMode.js) and whether the legend is folded away.
// Saved in the `map_toggles` cookie; kartvy's older `data_state` cookie (metric only) is read once if there's
// nothing newer.

const COOKIE = 'map_toggles';
const LEGACY_COOKIE = 'data_state';
const MAX_AGE_S = 60 * 60 * 24 * 365;
const METRIC_KEYS = ['totalScore', 'income', 'unemployment', 'education', 'ownedVsRented',
    'squareMeterPriceApartment', 'squareMeterPriceHouse'];

const cookies = new Cookies();

const readCookie = (name) => {
    try {
        const value = cookies.get(name);
        if (!value) return null;
        return typeof value === 'string' ? JSON.parse(value) : value;
    } catch (error) {
        return null;
    }
};

// checkedState with the saved metric and colour mode over the defaults.
export const readSavedCheckedState = (defaults) => {
    const saved = readCookie(COOKIE) || readCookie(LEGACY_COOKIE);
    if (!saved || typeof saved !== 'object') return { ...defaults };
    const metric = METRIC_KEYS.find((key) => saved.metric === key || saved[key] === true);
    const next = { ...defaults };
    if (metric) METRIC_KEYS.forEach((key) => { next[key] = key === metric; });
    next.hideMap = saved.hideMap === true;
    next.hideLines = next.hideMap && saved.hideLines === true;
    // No lines and no fill is "Av" now (the "Ingen" look, the overlay without fill or lines, was dropped).
    next.hideOverlay = next.hideLines;
    return next;
};

// The saved legend state, or the fallback (folded on phones) when nothing is saved.
export const readSavedLegendCollapsed = (fallback) => {
    const saved = readCookie(COOKIE);
    return typeof saved?.legendCollapsed === 'boolean' ? saved.legendCollapsed : fallback;
};

export const saveMapToggles = (checkedState, legendCollapsed) => {
    const metric = METRIC_KEYS.find((key) => checkedState?.[key]) || 'totalScore';
    try {
        cookies.set(COOKIE, JSON.stringify({
            metric,
            hideMap: Boolean(checkedState?.hideMap),
            hideLines: Boolean(checkedState?.hideMap && checkedState?.hideLines),
            hideOverlay: Boolean(checkedState?.hideMap && checkedState?.hideLines && checkedState?.hideOverlay),
            legendCollapsed: Boolean(legendCollapsed),
        }), { path: '/', maxAge: MAX_AGE_S });
    } catch (error) {
        // Cookies blocked: the toggles just reset next time.
    }
};

export const clearMapToggles = () => {
    cookies.remove(COOKIE, { path: '/' });
    cookies.remove(LEGACY_COOKIE, { path: '/' });
};
